import React from "react";
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from "react-redux";
import { pushNotification } from "utils/notifications";
import TatToanChoDuyetApi from "../../../../service/tatToanChoDuyetApi";
// import {
//     getListTatToanChoDuyet,
//     updateDataSearch,
// } from "../../../../actions/DanhSachTatToanChoDuyet";
const XoaTatToanHopDong = ({ show, onHide, item, SearchDanhSach }) => {
  const dispatch = useDispatch();
  // const listTatToanChoDuyetFull = useSelector(
  //     (state) => state.listTatToanChoDuyetFull
  // );
  const dataSearch = useSelector((state) => state.dataSearchTatToanChoDuyet);

  const deleteTatToanChoDuyet = () => () => {
    TatToanChoDuyetApi.xoaTatToanChoDuyet(item.TatToanChoDuyetID).then(
      (response) => {
        if (response.data.Error === 1) {
          pushNotification(response.data.Message, "error", "TOP_CENTER", 3000);
        } else {
          pushNotification(
            response.data.Message,
            "success",
            "TOP_CENTER",
            3000
          );
          SearchDanhSach();
          onHide();
        }
      }
    );
  };

  return (
    <Modal
      show={show}
      size="modal-dialog modal-dialog"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right"></span> Xác nhận xoá tất toán chờ
          duyệt
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={onHide}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <Modal.Body className="">
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="form-body">
              <div className="form-group row">
                <label
                  className="col-md-12 label-control text-left"
                  for="projectinput2"
                >
                  Bạn có chắc chắn muốn xóa tất toán chờ duyệt của hợp đồng{" "}
                  {item.Code} không?
                </label>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-new-main btn-checknew"
          onClick={deleteTatToanChoDuyet()}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-check"></i>
          </span>
          Xác nhận
        </button>

        <button
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>
          Đóng
        </button>
      </Modal.Footer>
    </Modal>
  );
};
export default XoaTatToanHopDong;
